import React, { useEffect, useMemo, useState } from "react";
import { MenuItem, Select } from "@mui/material";
import FeedbackBanner from "../../general/correct-feedback/FeedbackBanner";
import HtmlContent from "../../general/html-content/HtmlContent";

const DROP_PATTERN = /\[drop\]/g;
const getPlainTextLength = (html) => String(html || "").replace(/<[^>]*>/g, "").trim().length;
const getDropdownWidth = (options) => {
  const longestOption = options.reduce(
    (maxLength, option) => Math.max(maxLength, getPlainTextLength(option)),
    getPlainTextLength("Оберіть...")
  );

  return Math.max(150, Math.min(560, longestOption * 9 + 58));
};

const HtmlPart = ({ html }) => (
  <span
    className="dropdown2-html-part"
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

const Dropdown2Question = ({
  question,
  dropdowns,
  questionKey,
  onDropdownsChange,
  showCheckButton,
  canCheck,
  onCheck,
  feedbackVisible,
  feedback,
  onCloseFeedback,
  showNextButton,
  onNext,
  showFinishButton,
  onFinish,
}) => {
  const safeDropdowns = useMemo(() => (Array.isArray(dropdowns) ? dropdowns : []), [dropdowns]);
  const parts = useMemo(() => String(question || "").split(DROP_PATTERN), [question]);
  const dropdownCount = Math.max(0, parts.length - 1);
  const [values, setValues] = useState({});

  useEffect(() => {
    setValues({});
    onDropdownsChange({}, false);
  }, [dropdownCount, onDropdownsChange, question, questionKey]);

  function updateValue(idx, value) {
    const nextValues = { ...values, [`drop${idx}`]: value };
    const allSelected = Array.from({ length: dropdownCount }, (_, i) => nextValues[`drop${i}`])
      .every((item) => String(item || "").trim().length > 0);

    setValues(nextValues);
    onDropdownsChange(nextValues, allSelected);
  }

  return (
    <>
      <div className="dropdown2-question question-title">
        {parts.map((part, idx) => {
          const dropdown = safeDropdowns[idx] || {};
          const options = Array.isArray(dropdown.options) ? dropdown.options : [];

          return (
            <React.Fragment key={`${questionKey || "dropdown2"}-${idx}`}>
              <HtmlPart html={part} />
              {idx < dropdownCount && (
                <Select
                  className="dropdown2-select"
                  value={values[`drop${idx}`] || ""}
                  onChange={(e) => updateValue(idx, e.target.value)}
                  displayEmpty
                  renderValue={(selected) => selected
                    ? <HtmlContent html={selected} />
                    : "Оберіть..."}
                  inputProps={{ "aria-label": `Випадаючий список ${idx + 1}` }}
                  size="small"
                  sx={{ width: `${getDropdownWidth(options)}px` }}
                >
                  <MenuItem value="" disabled>Оберіть...</MenuItem>
                  {options.map((option, optionIdx) => (
                    <MenuItem key={`${option}-${optionIdx}`} value={option}>
                      <HtmlContent html={option} />
                    </MenuItem>
                  ))}
                </Select>
              )}
            </React.Fragment>
          );
        })}
      </div>

      {showCheckButton && canCheck && (
        <button className="btn checkAnswer" onClick={onCheck} style={{ display: "inline-block" }}>
          Перевірити
        </button>
      )}

      {feedbackVisible && <FeedbackBanner feedback={feedback} closeFeedback={onCloseFeedback} />}

      {showNextButton && (
        <button className="btn nextAnswer" onClick={onNext} style={{ display: "inline-block" }}>
          Наступне завдання
        </button>
      )}

      {showFinishButton && (
        <button className="btn nextAnswer" onClick={onFinish} style={{ display: "inline-block" }}>
          Завершити
        </button>
      )}
    </>
  );
};

export default Dropdown2Question;
